import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button } from "~/atoms/button";
import { Info, CheckCircle2 } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "~/atoms/alert";

type Props = {
  quizId: number;
  completed: boolean;
};

export function DocumentQuizConfirmation({ quizId, completed }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      {completed ? (
        <Alert variant="default">
          <CheckCircle2 className="text-success!" />
          <AlertTitle>
            {t(($) => $.anchoring.documentTab.completedTitle)}
          </AlertTitle>
          <AlertDescription>
            <span>
              {t(($) => $.anchoring.documentTab.completedDescription)}
            </span>
          </AlertDescription>
        </Alert>
      ) : (
        <Alert variant="warn">
          <Info className="text-warning-foreground! dark:text-warning!" />
          <AlertTitle>
            {t(($) => $.anchoring.documentTab.availableTitle)}
          </AlertTitle>
          <AlertDescription className="flex flex-col gap-2">
            <span>
              {t(($) => $.anchoring.documentTab.availableDescription)}
            </span>
            <Button
              size="sm"
              className="w-fit"
              onClick={() => void navigate(`/anchoring/${quizId}`)}
            >
              {t(($) => $.anchoring.documentTab.take)}
            </Button>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
